import { DocumentAcceptanceSchema } from '@retro-ui/prisma';
import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

const pathPrefix = '/document-acceptance';

export const documentAcceptanceContract = c.router(
  {
    signDocuments: {
      method: 'POST',
      path: '/sign-many',
      body: z.object({
        documents: z.array(DocumentAcceptanceSchema.pick({ name: true, version: true })),
      }),
      responses: {
        201: z.boolean(),
      },
    },
  },
  {
    pathPrefix,
    validateResponseOnClient: true,
  }
);
